import { useCallback, useEffect, useState } from "react";
import { url, ak } from "./HomePage";

function ServiceMunicipalitiesPage() {
  const [municipalities, setMunicipalities] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const loadMunicipalities = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        url + "/admin/service-municipalities" + ak,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("Palvelukuntien lataaminen epäonnistui.");
      }

      const data = await response.json();
      setMunicipalities(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || "Palvelukuntien lataaminen epäonnistui.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMunicipalities();
  }, [loadMunicipalities]);

  async function addMunicipality(event) {
    event.preventDefault();

    const trimmedName = name.trim();
    if (!trimmedName) return;

    setSaving(true);
    setError("");

    try {
      const response = await fetch(
        url + "/admin/service-municipalities" + ak,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name: trimmedName }),
        }
      );

      if (!response.ok) {
        throw new Error(
          response.status === 409
            ? "Kunta on jo lisätty."
            : "Kunnan lisääminen epäonnistui."
        );
      }

      setName("");
      await loadMunicipalities();
    } catch (err) {
      setError(err.message || "Kunnan lisääminen epäonnistui.");
    } finally {
      setSaving(false);
    }
  }

  async function setActive(municipality, active) {
    setError("");

    try {
      const response = await fetch(
        url +
          `/admin/service-municipalities/${municipality.id}/active` +
          ak,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ active }),
        }
      );

      if (!response.ok) {
        throw new Error("Palvelukunnan tilan muuttaminen epäonnistui.");
      }

      await loadMunicipalities();
    } catch (err) {
      setError(
        err.message || "Palvelukunnan tilan muuttaminen epäonnistui."
      );
    }
  }

  return (
    <div className="w-full flex justify-center pt-20">
      <div className="w-4/5 card p-8">
        <h1 className="text-3xl font-bold mb-2">Palvelukunnat</h1>

        <p className="mb-6">
          Työntekijä voi valita työskentelykunniksi vain aktiivisia
          palvelukuntia, enintään viisi.
        </p>

        <form
          onSubmit={addMunicipality}
          className="flex flex-row items-end gap-3 mb-8"
        >
          <div className="flex flex-col">
            <label className="font-bold mb-1" htmlFor="municipality-name">
              Lisää palvelukunta
            </label>

            <input
              id="municipality-name"
              className="border rounded h-10 px-3"
              value={name}
              maxLength={100}
              onChange={(event) => setName(event.target.value)}
              placeholder="Kunnan nimi"
            />
          </div>

          <button
            type="submit"
            disabled={saving || !name.trim()}
            className="bg-main font-bold text-white rounded h-10 px-5 drop-shadow-md disabled:opacity-50"
          >
            {saving ? "Lisätään..." : "Lisää"}
          </button>
        </form>

        {error && (
          <p className="text-red-600 font-bold mb-4">{error}</p>
        )}

        {loading ? (
          <p>Ladataan palvelukuntia...</p>
        ) : municipalities.length === 0 ? (
          <p>Palvelukuntia ei ole vielä lisätty.</p>
        ) : (
          <div className="flex flex-col gap-3">
            {municipalities.map((municipality) => (
              <div
                key={municipality.id}
                className="flex items-center justify-between border rounded p-4"
              >
                <div>
                  <p className="font-bold">{municipality.name}</p>
                  <p>
                    {municipality.active ? "Aktiivinen" : "Ei aktiivinen"}
                  </p>
                </div>

                <button
                  type="button"
                  className="bg-main font-bold text-white rounded h-10 px-5 drop-shadow-md"
                  onClick={() =>
                    setActive(municipality, !municipality.active)
                  }
                >
                  {municipality.active
                    ? "Poista käytöstä"
                    : "Ota käyttöön"}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ServiceMunicipalitiesPage;
